import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

export default function EhPageView() {
  const posthog = usePostHog();
  const { pathname } = useLocation();

  // Track pageviews manually in SPA
  useEffect(() => {
    // Remove sensitive query params before tracking
    const url = new URL(window.location.href);
    url.searchParams.delete('address');
    url.searchParams.delete('paymentId');
    const cleanUrl = url.toString();

    if (import.meta.env.DEV) {
      console.log('[DEV] posthog pageview', cleanUrl)
    }
    posthog.capture(
      '$pageview',
      {
        '$current_url': cleanUrl,
      }
    )
  }, [pathname, posthog])
  
  return null
} 